import React from 'react';
import ForgotPasswordForm from './ForgotPasswordForm';
import AuthPageSkeleton from '../components/AuthPageSkeleton';

/**
 * @component for forgot password
 */
const ForgotPassword: React.FC = () => {
  return (
    <AuthPageSkeleton>
      <ForgotPasswordForm />
    </AuthPageSkeleton>
  );
};

export default ForgotPassword;
